import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { DeleteUserBlockedDialogContent } from '../../utils/delete-user-error.util';

@Component({
  selector: 'bo-delete-user-blocked-dialog',
  standalone: true,
  imports: [TranslateModule, CommonModule, DialogModule],
  templateUrl: './delete-user-blocked-dialog.component.html',
  styleUrl: './delete-user-blocked-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeleteUserBlockedDialogComponent {
  @Input() visible = false;
  @Input() content: DeleteUserBlockedDialogContent | null = null;

  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() closed = new EventEmitter<void>();

  onVisibleChange(visible: boolean) {
    if (!visible) {
      this.closed.emit();
    }
    this.visibleChange.emit(visible);
  }

  onClose() {
    this.closed.emit();
    this.visibleChange.emit(false);
  }
}
